import React from "react";
import { MdExpandMore } from "react-icons/md";
import { getLocalizedText } from "../utils/textLocalization";
import { formatPrice } from "../utils/currencyUtils";

const RozbalovaciNabidka = ({
  options,
  selectedIndex,
  open,
  onToggle,
  onSelect,
  dropdownRef
}) => {
  if (!Array.isArray(options) || options.length === 0) {
    return null;
  }

  const selected = options[selectedIndex] || options[0];

  return (
    <div className="bike-example-spec-dropdown" ref={dropdownRef}>
      <h3>{getLocalizedText("bike.dropdown_offer")}</h3>
      <button
        type="button"
        className={`bike-example-spec-dropdown-trigger${open ? " open" : ""}`}
        onClick={onToggle}
        aria-expanded={open}
        aria-haspopup="listbox"
      >
        <span className="bike-example-spec-dropdown-name">{selected.name}</span>
        {selected.price ? (
          <span className="bike-example-spec-dropdown-price">{formatPrice(selected.price)}</span>
        ) : null}
        <MdExpandMore />
      </button>
      {open ? (
        <div className="bike-example-spec-dropdown-menu" role="listbox">
          {options.map((option, index) => (
            <button
              type="button"
              key={`${option.name}-${index}`}
              role="option"
              aria-selected={index === selectedIndex}
              className={index === selectedIndex ? "active" : ""}
              onClick={() => onSelect(index)}
            >
              <span className="bike-example-spec-dropdown-name">{option.name}</span>
              {option.price ? (
                <span className="bike-example-spec-dropdown-price">{formatPrice(option.price)}</span>
              ) : null}
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
};

export default RozbalovaciNabidka;
